// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dmj1","select":"styles_select__1_Ikq"};